package de.oevbs.kunde.kundenportal2.services.registration.store

import de.oevbs.kunde.kundenportal2.RegistrationStep
import de.oevbs.kunde.kundenportal2.components.GlobalServiceMessagesStore
import de.oevbs.kunde.kundenportal2.components.globalSubmitTracker
import de.oevbs.kunde.kundenportal2.model.services.registration.RegistrationMail
import de.oevbs.kunde.kundenportal2.services.registration.RegistrationClient
import de.oevbs.kunde.kundenportal2.util.tryCatchAndHandleErrors
import dev.fritz2.core.Handler
import dev.fritz2.core.invoke
import dev.fritz2.core.storeOf
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.validation.ValidatingStore
import dev.fritz2.validation.valid
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.Flow

class RegistrationMailStore(job: Job) :
    ValidatingStore<RegistrationMail, Unit, ComponentValidationMessage>(
        initialData = RegistrationMail(),
        validation = RegistrationMail.validation,
        metadataDefault = Unit,
        validateAfterUpdate = false,
        job = job
    ) {

    private val client = RegistrationClient()

    private val progressStore = storeOf(RegistrationStep.MAIL1, job)
    val currentStep: Flow<RegistrationStep> = progressStore.data


    /**
     * Handler Schritt 1: handleMailAddressInput
     * Die Schaltfläche „Weiter“ in Schritt 1 wurde geclickt nach Angabe der Mailadresse.
     *
     * Dieser Handler verwendet den Registration-Validator mit Step1-Metadaten, um die Maileingaben des Benutzers aus
     * Schritt 1 des Reg-Prozesses zu validieren.
     * Wenn die Eingaben gültig sind, wird [saveNewRegistration] aufgerufen, um ein aktualisiertes Reg-Objekt zu
     * erhalten.
     */
    val handleMailAddressInput: Handler<Unit> = handle { registration ->

        GlobalServiceMessagesStore.clear()

        if (!validate(registration).valid) {
            return@handle registration
        }

        if (!globalSubmitTracker.track {
                saveNewRegistration(registration)
            }) return@handle registration

        progressStore.update(RegistrationStep.MAILSUCCESS2)

        RegistrationMail()
    }

    /**
     * saveNewRegistration: Wird in Schritt 1 des Registrierungsprozesses von [handleMailAddressInput] aufgerufen.
     *
     * Diese Funktion sendet [registration] an den Service, um einen neuen Reg-Prozess zu starten.
     * Ein Benutzer (identifiziert durch seine Mail-Adresse nur während des Registrierungsprozesses, später nur durch den
     * Benutzernamen) kann nur 4 Links pro Tag anfordern (jeder Registrierungsversuch = 1).
     * Der Zähler wird am nächsten Tag zurückgesetzt, falls eine neue Anforderung reinkommt.
     * Der Server versucht, ein neues Registrierungsobjekt zu erstellen, sendet eine Verify-Mail an den
     * Benutzer.
     * @param registration Eingaben des Users
     * @return True im Erfolgsfall. False, wenn ein Fehler auftritt.
     */
    private suspend fun saveNewRegistration(registration: RegistrationMail): Boolean {
        return tryCatchAndHandleErrors("Schritt 1 der Registrierung") {
            client.createOrUpdate(registration)
        } != null
    }
}